<template>
  <div class="module-edit">
    <add-or-update />
  </div>
</template>

<script>
import AddOrUpdate from "../_partial";
export default {
  meta: {
    headName: "Edit Service",
  },
  components: { AddOrUpdate },
};
</script>
